import React from 'react';
import {
    Dialog,
    DialogContent,
    DialogTitle,
    DialogActions,
} from '@mui/material';
import Title from '../title/title';

const CustomDialog = (props) => {
    const { handleClose, open, fullWidth } = props;

    return (
        <Dialog
            onClose={() => handleClose(false)}
            open={open}
            fullWidth={fullWidth} {...props}>
            {props.title ? <DialogTitle sx={{pt: 1, pb: 1, pl: 3, pr: 3}}><Title title={props.title} /></DialogTitle> : null}
            <DialogContent dividers classes={props.dialogContentClasses ? props.dialogContentClasses : {}}>{props.renderContent()}</DialogContent>
            <DialogActions>{props.renderActions()}</DialogActions>
        </Dialog>
    );
};
export default CustomDialog;
